import Cookies from 'js-cookie'
import {HTTP} from './axios'

const TokenKey = 'ig-en'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}


